<template>
  <!--厂家/县代销量组件-->
  <tk-container
    :status="status"
    class="bg-white"
    @refresh="getInit"
  >
    <tkui-list>
      <tkui-list-picker
        v-if="salesType === 'year'"
        @selected="selectedDate"
        v-model="yearVal"
        :items="dateYObj"
        :placeholder="'请选择年份'"
      ></tkui-list-picker>
      <tk-flex
        class="full-width"
        right
        v-else
      >
        <tkui-list-picker
          @selected="selectedDate"
          v-model="yearVal"
          :items="dateYObj"
          :placeholder="'请选择年份'"
        ></tkui-list-picker>
        <tkui-list-picker
          @selected="selectedMDate"
          v-model="monthVal"
          :items="dateMObj"
          :placeholder="'请选择月份'"
        ></tkui-list-picker>
      </tk-flex>
    </tkui-list>
    <div class="m-x-12 m-t-20">
      <div class="bg-image" :style="`background-image: url(${bgImage}) !important`">
        <div class="decoration-text">{{salesType === 'year' ? yearVal + '年' : monthVal + '月'}}</div>
        <tk-flex center column>
          <div class="font-13 text-white m-t-24">订单金额</div>
          <div class="font-32 text-white m-t-15"><span class="font-10">￥</span>{{groupAllAmount}}</div>
        </tk-flex>
      </div>
    </div>
    <template v-if="userSales.length">
      <tk-card
        class="p-x-12 p-y-4 sales-card m-t-10"
        :width="100"
        :height="100"
        v-for="(s, index) in userSales"
        :key="index"
      >
        <sales-commodity-single
          :commodity="s.commodity"
          :image-size="110"
          :amount="Number(s.sum)"
        >
        </sales-commodity-single>
      </tk-card>
    </template>
    <div style="height: 20px;"></div>
  </tk-container>
</template>

<script>
import salesCommoditySingle from '@/components/salesCommoditySingle'
export default {
  components: {
    salesCommoditySingle
  },
  props: {
    bgImage: {
      type: String
    },
    salesType: {
      type: String
    }
  },
  data () {
    return {
      status: 'loading', // 页面状态
      yearVal: new Date().getFullYear().toString(), // 默认时间值
      monthVal: '', // 默认时间值
      dateYObj: {}, // 日期的列表数据
      dateMObj: {}, // 日期的列表数据
      groupAllAmount: 0, // 所选年份或月份总销售金额
      userSales: [] // 商品销量数据
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
     * @Description: 数据初始化
     * @author xiaozan
     * @date 2020/5/5
     */
    async getInit () {
      try {
        await this.getDateList() // 获取时间选择数据
        await this.getGroupOrder() // 统计订单销量
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /*
    * 获取月份数据
    */
    getMonthData (date) {
      this.monthVal = '1'
      this.dateMObj = { 1: '1月' }
      let endMonth = new Date(date).getMonth() + 1
      let startMonth = 1
      let diffSum = endMonth - startMonth
      if (diffSum === 0) {
        this.dateMObj = { 1: '1月' }
      }
      if (diffSum > 0) {
        for (let i = 0; i < (endMonth - startMonth + 1); i++) {
          this.dateMObj[(endMonth - i).toString()] = (endMonth - i).toString() + '月'
        }
      }
    },
    /**
    * 获取时间选择数据
    * @date: 2020/5/6
    */
    async getDateList () {
      let year = new Date().getFullYear()
      this.yearVal = year.toString()
      this.dateYObj = { 2020: '2020' + '年' }
      let endYear = new Date().getFullYear()
      let startYear = 2020
      let diffSum = endYear - startYear
      if (diffSum === 0) { this.dateYObj = { year: this.yearVal + '年' } }
      if (diffSum > 0) {
        for (let i = 0; i < (endYear - startYear + 1); i++) {
          this.dateYObj[(endYear - i).toString()] = (endYear - i).toString() + '年'
        }
      }
      if (this.salesType !== 'year') {
        this.getMonthData(this.yearVal)
      }
    },
    /**
     * @Description: 转换一年的起始时间结束时间
     * @author xiaozan
     * @date 2020/5/5
     */
    convertYear (year) {
      return {
        isoStartDate: this.$tkDate(year).startOf('year').toISOString(),
        isoEndDate: this.$tkDate(year).endOf('year').toISOString()
      }
    },
    /**
     * @Description: 转换每个月的起始时间结束时间
     * @author xiaozan
     * @date 2020/5/5
     */
    convertMonth (month, year) {
      return {
        isoStartDate: this.$tkDate(new Date(year).getFullYear() + '-' + month).startOf('month').toISOString(),
        isoEndDate: this.$tkDate(new Date(year).getFullYear() + '-' + month).endOf('month').toISOString()
      }
    },
    /**
     * @Description: 调用接口
     * @author xiaozan
     * @date 2020/5/5
     */
    async transferParse (sum, isoStartDate, isoEndDate, key) {
      let obj = {
        createdAt: {
          $gte: {
            '__type': 'Date',
            'iso': isoStartDate
          },
          $lte: {
            '__type': 'Date',
            'iso': isoEndDate
          }
        },
        isDeleted: false
      }
      if (this.isCountyAccount) { obj.buyUser = this.userInfo.objectId } else {
        obj.merchants = this.userInfo.objectId
      }
      // eslint-disable-next-line no-return-await
      return await this.$tkParse.group('/classes/factoryOrders', key, {
        params: {
          select: {
            sum: {
              $sum: sum
            }
          },
          where: obj
        }
      })
    },
    /**
     * @Description: 统计每年订单销量订单金额
     * @author xiaozan
     * @date 2020/5/5
     */
    async getYearGroupOrder (year) {
      let s = this.convertYear((year).toString())
      let groupYear = await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'commodity')
      let arr = groupYear.data.results
      if (!arr.length) {
        this.groupAllAmount = 0
        return []
      }
      // 获取选择年的总销量
      if (this.isFactoryAccount) {
        this.groupAllAmount = (await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'merchants')).data.results[0].sum
      } else {
        this.groupAllAmount = (await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'buyUser')).data.results[0].sum
      }
      // arr.forEach(s => {
      //   this.$tkParse.batch.get('/classes/commodity', {
      //     params: {
      //       limit: 1,
      //       where: {
      //         objectId: s.objectId
      //       }
      //     }
      //   })
      // })
      // let commodityList = await this.$tkParse.batch.run()
      let commodityList = []
      for (let i = 0; i < arr.length; i++) {
        let s = arr[i]
        let res = await this.$tkParse.get('/classes/commodity', {
          params: {
            limit: 1,
            where: {
              objectId: s.objectId
            }
          }
        })
        commodityList.push(res)
      }
      return arr.map((s, index) => {
        s.commodity = commodityList[index].data.results[0]
        s.sum = Number(s.sum.toString()).toLocaleString()
        return s
      }).sort((a, b) => {
        return b.sum - a.sum
      })
    },
    /**
     * @Description: 统计每年订单销量订单金额
     * @author xiaozan
     * @date 2020/5/5
     */
    async getMonthGroupOrder (month, year) {
      // 每月销量数据
      let s = this.convertMonth(month.toString(), year.toString())
      let groupMonth = await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'commodity')
      let arr = groupMonth.data.results
      if (!arr.length) {
        this.groupAllAmount = 0
        return []
      }
      // 获取选择月的总销量
      if (this.isFactoryAccount) {
        this.groupAllAmount = (await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'merchants')).data.results[0].sum
      } else {
        this.groupAllAmount = (await this.transferParse('consumptionAmount', s.isoStartDate, s.isoEndDate, 'buyUser')).data.results[0].sum
      }
      // arr.forEach(s => {
      //   this.$tkParse.batch.get('/classes/commodity', {
      //     params: {
      //       limit: 1,
      //       where: {
      //         objectId: s.objectId
      //       }
      //     }
      //   })
      // })
      // let commodityList = await this.$tkParse.batch.run()
      let commodityList = []
      for (let i = 0; i < arr.length; i++) {
        let s = arr[i]
        let res = await this.$tkParse.get('/classes/commodity', {
          params: {
            limit: 1,
            where: {
              objectId: s.objectId
            }
          }
        })
        commodityList.push(res)
      }
      return arr.map((s, index) => {
        s.commodity = commodityList[index].data.results[0]
        s.sum = Number(s.sum.toString()).toLocaleString()
        return s
      }).sort((a, b) => {
        return b.sum - a.sum
      })
    },
    /**
     * @Description: 统计数据
     * @author xiaozan
     * @date 2020/5/5
     */
    async getGroupOrder () {
      if (this.salesType === 'year') {
        this.userSales = await this.getYearGroupOrder(Number(this.yearVal))
      } else {
        this.userSales = await this.getMonthGroupOrder(Number(this.monthVal), Number(this.yearVal))
      }
    },
    /**
    * 选定date
    * @date: 2020/5/6
    */
    async selectedDate () {
      let year = new Date().getFullYear()
      if (this.salesType !== 'year') {
        if (year === Number(this.yearVal)) {
          this.getMonthData(this.yearVal.toString())
        } else {
          this.getMonthData(this.yearVal.toString() + '-12')
        }
      }
      await this.getGroupOrder()
    },
    /**
     * 选定date
     * @date: 2020/5/6
     */
    async selectedMDate () {
      await this.getGroupOrder()
    }
  }
}
</script>

<style scoped lang="scss">
  // 首个排行背景图
  .bg-image {
    width: 100%;
    height: 154px;
    background-repeat:  no-repeat;
    background-size: 100% 154px;
    padding-top: 15px;
    box-shadow:0 3px 35px 0 rgba(0, 0, 0, 0.06);
    .decoration-text {
      width: 60px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-top-left-radius: 10px;
      border-bottom-right-radius: 10px;
      background: #fece33;
      font-size: 13px;
      color: rgba(140, 72, 42, 1);
    }
  }
  ::v-deep .tkui-list-picker .right {
    padding-right: 15px !important;
  }
  // 列表样式
  .sales-card {
    box-shadow:0 3px 35px 0 rgba(0, 0, 0, 0.06);
    .decoration-text {
      width: 60px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;
      background: #FEEFD8;
      font-size: 13px;
      color: rgba(182,141,94,1);
    }
  }
</style>
